module.exports = __webpack_public_path__ + "img/three.05238b33.png";